import React from 'react';
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import { DEFAULT_IMAGE } from 'config/restaurant.const';
import { IProduct } from 'features/order/types/product.types';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import SkeletonLoader from 'components/SkeletonLoader';
import { useAppSelector } from 'app/hooks';
import { orderLoadStore } from 'features/order/stores/order-load.slice';
import { CardDescriptionContainer } from 'features/order/components/CardDescriptionContainer';

interface IFeatureProductCardHorizontalProps {
   item: IProduct;
   handleProductSelection: (productId: string) => void;
}

const FeatureProductCardHorizontal: React.FC<IFeatureProductCardHorizontalProps> = ({
   item,
   handleProductSelection,
}) => {
   const cardRef = React.useRef<HTMLDivElement>(null);
   const { cardLoading } = useAppSelector(orderLoadStore);

   return (
      <Card
         ref={cardRef}
         className="product-card"
         sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
         style={{ borderRadius: '1rem', cursor: 'pointer' }}
      >
         <SkeletonLoader
            loading={cardLoading}
            skeletonProps={{ width: '100%', height: cardRef.current ? cardRef.current.offsetHeight : '128px' }}
         >
            <Box display="flex" flexDirection="column" margin="auto">
               <CardContent
                  sx={{ flex: '1 0 auto', padding: '10px', ':last-child': { paddingBottom: '0px' } }}
                  onClick={() => {
                     handleProductSelection(item.id);
                  }}
               >
                  <Typography
                     sx={{ fontWeight: 600 }}
                     gutterBottom
                     variant="subtitle1"
                     component="div"
                     className="card-content"
                  >
                     {item.name}
                  </Typography>
                  <CardDescriptionContainer className="card-content">
                     {(item.specifications || item.description) && (
                        <Markdown remarkPlugins={[remarkGfm]}>
                           {item.specifications?.length
                              ? item.specifications.replace(/\t/g, '   ')
                              : item.description.replace(/\t/g, '   ')}
                        </Markdown>
                     )}
                  </CardDescriptionContainer>
               </CardContent>
            </Box>
            <CardMedia
               sx={{ minWidth: 136, maxWidth: 136, minHeight: 136, maxHeight: 136 }}
               component="img"
               height="140"
               image={item?.images && item.images.length ? `${item.images[0][3].url}` : DEFAULT_IMAGE}
               alt={item.name}
               onClick={() => {
                  handleProductSelection(item.id);
               }}
            />
         </SkeletonLoader>
      </Card>
   );
};

export default FeatureProductCardHorizontal;
